<template>
	<div class="page-container flex-column">
		<main class="main flex-column flex1">
			<div class="brief-intro-box">
				<div class="brief-intro">
					<h2 class="box-title">{{ detail.knowledgeName }}</h2>
					<MultiLineExpandsCollapses id="intro" :content="detail.description" />
				</div>
			</div>

			<!-- 内容列表 -->
			<div class="content-list-box">
				<div class="title-line">
					<div class="box-title title-line-left">关联内容</div>
				</div>

				<van-list v-model="loading" :finished="finished" :finished-text="list.length ? '没有更多了' : ''" @load="onLoad">
					<van-empty
						v-if="!list.length && !loading"
						class="custom-image"
						:image="require('@/assets/image/ic_search.png')"
						:image-size="114"
						description="暂无内容～" />

					<div class="card-wrapper" v-else>
						<Card
							class="card"
							v-for="item in list"
							:key="item.id"
							@click="handleClickJumpDetailsPageByResourceType(item)"
							lazy-load
							currency=""
							:tag="resourceType[item.resourceType]"
							:thumb="item.cover"
							:headerStyle="{ width: 'calc(100vw / 2 - 20px)', borderRadius: '5px', flexDirection: 'column' }"
							:thumbStyle="{ width: '100%', height: '103px' }">
							<template #title>
								<span class="text van-ellipsis block">{{ item.name }}</span>
							</template>
							<template #price>
								<span class="price">{{ item.price || 0 }}</span>
								<span class="unit"> 巢币</span>
							</template>
						</Card>
					</div>
				</van-list>
			</div>
		</main>
	</div>
</template>

<script>
import WxShare from "@/utils/wxshare";
import Card from "./components/Card.vue";
import MultiLineExpandsCollapses from "./components/MultiLineExpandsCollapses.vue";
import { getImageUrl, isHttp } from "@/utils/upload";

// 指派类型 0：课程 1：培训计划
const ASSIGN_TYPE = {
	0: "课程",
	1: "培训计划"
};

export default {
	components: {
		Card,
		MultiLineExpandsCollapses
	},

	data() {
		return {
			resourceType: Object.freeze(ASSIGN_TYPE),
			list: [],
			loading: false,
			finished: false,
			page: 1,
			pageSize: 10,
			total: 0,
			detail: {}
		};
	},

	created() {
		this.getKnowledgePointsInfo();
		this.init();
	},

	methods: {
		init() {
			this.getWx = new WxShare();
		},
		/**获取知识点详情简介 */
		async getKnowledgePointsInfo() {
			const data = new FormData();
			data.append("api", "system/outApi/knowledge/detail");
			data.append("primaryId", this.$route.query.id);

			this.$http({
				url: "/ipd/commonApi",
				method: "post",
				data
			}).then((res) => {
				if (res.code < 0) {
					return this.$router.replace({
						path: "/learningEmpty"
					});
				}

				this.detail = res.data?.item || {};

				document.title = this.detail.knowledgeName || "知识点详情";

				/* 微信分享 */
				this.getWx.share({
					title: this.detail.knowledgeName,
					desc: "电子产业链人才智慧培养和提升一站式数字化服务平台",
					link: window.location.href,
					imgUrl: "https://prod-1251541497.cos.ap-guangzhou.myqcloud.com/app_backend_new/app/default.png"
				});
			});
		},

		/** 分页加载列表 */
		async onLoad() {
			const data = new FormData();
			data.append("api", "kc/app/cTrain/resource/list");
			data.append("page", this.page);
			data.append("pageSize", this.pageSize);
			data.append("knowledgeId", this.$route.query.id);

			this.$http({
				url: "/ipd/commonApi",
				method: "post",
				data
			}).then((res) => {
				if (res.code < 0) {
					return this.$router.replace({
						path: "/learningEmpty"
					});
				}

				this.loading = false;
				if (this.list.length >= res.data.total) return (this.finished = true);
				this.list.push(...(res.data.items || []));
				this.page = this.page + 1;

				if (this.list.length > 0) {
					this.list.forEach((item) => {
						if (item.cover && !isHttp(item.cover)) {
							getImageUrl(item.cover, (imgUrl) => {
								this.$set(item, "cover", imgUrl);
							});
						}
					});
				}
			});
		},

		/**
		 * 点击卡片根据资源类型跳转到对应资源的详情页
		 */
		handleClickJumpDetailsPageByResourceType(item) {
			// 0：课程 1：培训计划
			if (Number(item.resourceType) === 1) {
				this.$router.push({
					path: "/training",
					query: { trainId: item.id }
				});
			} else {
				this.$router.push({
					path: "/trainingCourse",
					query: { courseId: item.id }
				});
			}
		}
	}
};
</script>

<style scoped>
.page-container {
	--color-primary: #f7433f;
}
.page-container {
	height: 100vh;
	background-color: #f7f8f8;
}
.flex-column {
	display: flex;
	flex-direction: column;
}
.flex1 {
	flex: 1;
	overflow-y: auto;
}

.header /deep/.headerMod {
	border: 0;
}

.main::-webkit-scrollbar {
	display: none;
}

.user-info {
	display: flex;
	align-items: center;
	margin-top: 5px;
}

.avatar {
	justify-content: stretch;
	align-self: self-start;
	flex-shrink: 0;
}

.user-info .text-box {
	margin-left: 13px;
}
.user-info__name {
	font-weight: 500;
	font-size: 17px;
	color: #333333;
	margin-bottom: 5px;
}

.brief-intro-box {
	font-size: 13px;
	color: #555555;
	line-height: 18px;
	text-align: justify;
	background-color: #fff;
	padding: 15px 10px;
}

.brief-intro-box .box-title {
	padding-top: 0;
}

/* 内容 */
.content-list-box {
	margin-top: 10px;
	background-color: #fff;
	flex: 1;
	padding: 0 15px;
}

.box-title {
	font-size: 17px;
	font-weight: 500;
	color: #333333;
	padding: 8px 0;
}

.card-wrapper {
	display: flex;
	flex-wrap: wrap;
	/* gap: 15px 10px; */
}

.card {
	margin-bottom: 15px;
}

.card:nth-child(2n) {
	margin-left: 10px;
}

.block {
	display: block;
	width: 100%;
	margin-bottom: 7px;
}

.price,
.unit {
	color: var(--color-primary);
}

.price {
	font-size: 14px;
}

.unit {
	font-size: 10px;
	vertical-align: 1px;
}

.bnt-share {
	width: 25px;
	height: 25px;
}

/* * {
	box-shadow: 0 0 1px 0 pink;
} */

/* 无内容 */
.custom-image /deep/.van-empty__description {
	margin-top: 0;
	font-size: 13px;
	color: #c0c4cc;
	line-height: 12px;
}
</style>

